import style from "./Plans.module.css";
import ChoosePlan from "@/features/auth/components/choosePlan/ChoosePlan";
import Container from "@/layouts/container/Container";

function Plans() {
	return (
		<div className={style.page}>
			<Container size="mini">
				<ChoosePlan />
			</Container>
		</div>
	);
}

export default Plans;
